export default __webpack_public_path__ + "static/media/Grandmaster_Mentor.63eef98f.png";